import React from "react";
import MobileCard from "../SalesAndMarketing/components/MobileCard";
import { StatusField } from "./components/CustomColumns";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { formatRevenue } from "features/Common/utils/common.utils";

const LimitedOfferMobileCard = ({
  record,
  onSeeMore,
  columns,
  onMoreActions,
  isAlternate,
}) => {
  const content = columns
    .filter((column) => column.showInCard)
    .map((column) => {
      const value = column.valueFormatter
        ? column.valueFormatter(record)
        : record?.[column.field] ?? column.emptyField ?? "N/A";

      return {
        title: column.headerName,
        value,
      };
    });

  return (
    <MobileCard
      className={isAlternate ? "tw-bg-[#F6F6F6]" : ""}
      header={
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center tw-gap-2">
            <AccessAlarmIcon
              style={{
                fontSize: 24,
                color: "#0000004D",
              }}
            />

            <div className="tw-font-medium tw-text-[16px]">{record?.title}</div>
          </div>

          <div className="tw-flex tw-items-center tw-gap-2">
            <StatusField record={record} />

            {record.status !== 2 && (
              <MoreHorizIcon
                className="tw-cursor-pointer"
                onClick={onMoreActions}
              />
            )}
          </div>
        </div>
      }
      content={content}
      stats={[
        {
          title: "Leads",
          data: record?.total_leads || 0,
          color: "#086F86",
          icon: "leadIcon.png",
        },
        {
          title: "Bookings",
          data: record?.total_bookings || 0,
          color: "#493AB1",
          icon: "booking.png",
        },
        {
          title: "Revenue",
          data: formatRevenue(record?.total_revenue, null, 2),
          color: "#1DBE8A",
          icon: "revenue.png",
        },
      ]}
      statColumns={3}
      footer={
        <div
          onClick={onSeeMore}
          className="tw-flex tw-justify-end tw-items-center tw-bg-[#EEECF9] tw-w-full tw-px-2 tw-py-4 tw-gap-1 tw-cursor-pointer"
        >
          <p className="tw-text-[#493AB1] tw-underline tw-m-0">See more</p>

          <ArrowForwardIosIcon
            style={{
              fontSize: 16,
              color: "#493AB1",
            }}
          />
        </div>
      }
    />
  );
};

export default LimitedOfferMobileCard;
